export default __webpack_public_path__ + "static/media/admin_product_setting_icon.45898f96.svg";